// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={152}
    height={152}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={152}
      height={152}
      fill="white"
    />
    <path
      d="M46.1587 42.0649L106.093 41.9653V122.26H46.1587V42.0649Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M46.161 103.85C44.7797 115.734 36.2697 115.734 36.2697 115.734H96.0118C96.0118 115.734 106.093 115.734 106.093 100.415L46.161 103.85Z"
      fill="#FFD5E1"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M46.1587 41.9695H106.093V98.9511C106.093 99.6025 105.965 100.247 105.716 100.849C105.467 101.451 105.102 101.998 104.641 102.458C104.181 102.919 103.634 103.284 103.032 103.533C102.43 103.783 101.785 103.911 101.134 103.91H46.1609L46.1587 41.9695Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M100.979 103.911C100.979 103.911 96.2755 103.911 96.2755 97.611H36.5312C36.5312 103.417 41.2368 103.913 41.2368 103.913L100.979 103.911Z"
      fill="#FF9DBE"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M55.3588 59.7982H96.0835"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M55.3588 75.4278H96.0835"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M76.0996 51.9539H91.0906"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M55.3117 51.9539H71.0998"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M76.0996 67.5787H91.0906"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M55.3339 67.5787H71.0993"
      stroke="#29292F"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M55.4272 91.1735C55.4272 91.1735 55.8551 83.7092 58.9525 83.5297C62.145 83.3481 61.3078 89.3148 63.8018 89.8138C66.0506 90.2538 66.7166 85.0001 70.0337 85.257C73.7441 85.5388 72.5228 90.3558 86.2661 89.6953"
      stroke="#F95396"
      strokeWidth={0.666667}
      strokeMiterlimit={10}
    />
    <path
      d="M59.2658 46.1406C51.2969 45.3438 52.8907 35.7813 58.4688 35.7812C63.2501 35.7812 64.5782 40.0312 63.2501 42.1562"
      stroke="#29292F"
      strokeWidth={0.67}
    />
    <circle
      cx={59.2656}
      cy={46.1406}
      r={0.796875}
      fill="#29292F"
    />
    <path
      d="M77.1881 46.1406C69.2192 45.3438 70.813 35.7813 76.3911 35.7812C81.1724 35.7812 82.5005 40.0312 81.1724 42.1562"
      stroke="#29292F"
      strokeWidth={0.67}
    />
    <circle
      cx={77.188}
      cy={46.1406}
      r={0.796875}
      fill="#29292F"
    />
    <path
      d="M95.1104 46.1406C87.1415 45.3438 88.7353 35.7813 94.3134 35.7812C99.0947 35.7812 100.423 40.0312 99.0947 42.1562"
      stroke="#29292F"
      strokeWidth={0.67}
    />
    <circle
      cx={95.1102}
      cy={46.1406}
      r={0.796875}
      fill="#29292F"
    />
    <path
      d="M101.558 24.1744C103.797 24.2612 105.911 25.2829 107.437 27.015C108.962 28.747 109.773 31.0476 109.692 33.4108C109.732 32.2405 109.99 31.0901 110.452 30.0253C110.913 28.9605 111.569 28.002 112.382 27.2048C113.194 26.4075 114.148 25.7871 115.188 25.3788C116.227 24.9706 117.333 24.7826 118.442 24.8256C117.333 24.783 116.243 24.5103 115.234 24.0231C114.226 23.5358 113.318 22.8436 112.562 21.9859C111.807 21.1282 111.219 20.1218 110.833 19.0242C110.446 17.9267 110.268 16.7595 110.308 15.5892C110.268 16.7595 110.01 17.9099 109.548 18.9747C109.087 20.0395 108.431 20.998 107.618 21.7952C106.806 22.5925 105.852 23.2129 104.812 23.6212C103.773 24.0294 102.667 24.2174 101.558 24.1744Z"
      fill="white"
    />
    <path
      d="M101 24.1538L101.558 24.1744M101.558 24.1744C103.797 24.2612 105.911 25.2829 107.437 27.015C108.962 28.747 109.773 31.0476 109.692 33.4108M101.558 24.1744C102.667 24.2174 103.773 24.0294 104.812 23.6212C105.852 23.2129 106.806 22.5925 107.618 21.7952C108.431 20.998 109.087 20.0395 109.548 18.9747C110.01 17.9099 110.268 16.7595 110.308 15.5892M109.692 33.4108L109.669 34M109.692 33.4108C109.732 32.2405 109.99 31.0901 110.452 30.0253C110.913 28.9605 111.569 28.002 112.382 27.2048C113.194 26.4075 114.148 25.7871 115.188 25.3789C116.227 24.9706 117.333 24.7826 118.442 24.8256M118.442 24.8256L119 24.8491M118.442 24.8256C117.333 24.783 116.243 24.5103 115.234 24.0231C114.226 23.5358 113.318 22.8436 112.562 21.9859C111.807 21.1282 111.219 20.1218 110.833 19.0242C110.446 17.9267 110.268 16.7595 110.308 15.5892M110.308 15.5892L110.328 15"
      stroke="#29292F"
      strokeWidth={0.413422}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M115.372 44.7944C116.865 44.8492 118.274 45.4945 119.291 46.5884C120.308 47.6823 120.849 49.1353 120.794 50.6278C120.821 49.8888 120.993 49.1622 121.301 48.4897C121.609 47.8171 122.046 47.2118 122.588 46.7083C123.13 46.2048 123.765 45.8129 124.458 45.5551C125.152 45.2972 125.889 45.1785 126.628 45.2056C125.889 45.1787 125.162 45.0065 124.49 44.6988C123.817 44.3911 123.212 43.9538 122.708 43.4121C122.205 42.8704 121.813 42.2348 121.555 41.5416C121.297 40.8484 121.178 40.1112 121.206 39.3722C121.179 40.1113 121.007 40.8378 120.699 41.5103C120.391 42.1829 119.954 42.7882 119.412 43.2917C118.87 43.7952 118.235 44.1871 117.542 44.4449C116.848 44.7028 116.111 44.8215 115.372 44.7944Z"
      fill="white"
    />
    <path
      d="M115 44.7814L115.372 44.7944M115.372 44.7944C116.865 44.8492 118.274 45.4945 119.291 46.5884C120.308 47.6823 120.849 49.1353 120.794 50.6278M115.372 44.7944C116.111 44.8215 116.848 44.7028 117.542 44.4449C118.235 44.1871 118.87 43.7952 119.412 43.2917C119.954 42.7882 120.391 42.1829 120.699 41.5103C121.007 40.8378 121.179 40.1113 121.206 39.3722M120.794 50.6278L120.78 51M120.794 50.6278C120.821 49.8887 120.993 49.1622 121.301 48.4897C121.609 47.8171 122.046 47.2118 122.588 46.7083C123.13 46.2048 123.765 45.8129 124.458 45.5551C125.152 45.2972 125.889 45.1785 126.628 45.2056M126.628 45.2056L127 45.2205M126.628 45.2056C125.889 45.1787 125.162 45.0065 124.49 44.6988C123.817 44.3911 123.212 43.9538 122.708 43.4121C122.205 42.8704 121.813 42.2348 121.555 41.5416C121.297 40.8484 121.178 40.1112 121.206 39.3722M121.206 39.3722L121.219 39"
      stroke="#29292F"
      strokeWidth={0.413422}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M24.359 84.5896C25.7988 84.6424 27.1586 85.2649 28.1395 86.3202C29.1203 87.3754 29.6419 88.777 29.5896 90.2168C29.6155 89.5039 29.7816 88.803 30.0785 88.1542C30.3753 87.5055 30.7971 86.9215 31.3196 86.4358C31.8422 85.9501 32.4553 85.5721 33.124 85.3234C33.7927 85.0746 34.5039 84.9601 35.2168 84.9863C34.5038 84.9603 33.803 84.7942 33.1542 84.4973C32.5055 84.2005 31.9215 83.7787 31.4358 83.2562C30.9501 82.7336 30.5721 82.1205 30.3234 81.4518C30.0746 80.7831 29.9601 80.072 29.9863 79.359C29.9603 80.072 29.7942 80.7729 29.4973 81.4216C29.2005 82.0704 28.7787 82.6543 28.2562 83.14C27.7336 83.6257 27.1205 84.0038 26.4518 84.2525C25.7831 84.5012 25.072 84.6157 24.359 84.5896Z"
      fill="white"
    />
    <path
      d="M24 84.577L24.359 84.5896M24.359 84.5896C25.7988 84.6424 27.1586 85.2649 28.1395 86.3202C29.1203 87.3754 29.6419 88.777 29.5896 90.2168M24.359 84.5896C25.072 84.6157 25.7831 84.5012 26.4518 84.2525C27.1205 84.0038 27.7336 83.6257 28.2562 83.14C28.7787 82.6543 29.2005 82.0704 29.4973 81.4216C29.7942 80.7729 29.9603 80.072 29.9863 79.359M29.5896 90.2168L29.5752 90.5758M29.5896 90.2168C29.6155 89.5039 29.7816 88.803 30.0785 88.1542C30.3753 87.5055 30.7971 86.9215 31.3196 86.4358C31.8422 85.9501 32.4553 85.5721 33.124 85.3234C33.7927 85.0746 34.5039 84.9601 35.2168 84.9863M35.2168 84.9863L35.5758 85.0006M35.2168 84.9863C34.5038 84.9603 33.803 84.7942 33.1542 84.4973C32.5055 84.2005 31.9215 83.7787 31.4358 83.2562C30.9501 82.7336 30.5721 82.1205 30.3234 81.4518C30.0746 80.7831 29.9601 80.072 29.9863 79.359M29.9863 79.359L29.9988 79"
      stroke="#29292F"
      strokeWidth={0.413422}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgNotes = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgNotes;
